.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(198px, 1fr));
  gap: var(--space-5);
  padding: var(--space-6);
  background: #fff;
}
